import type { MergeTagRegistry } from 'tailwind-v4/blocks/email-builder'

/**
 * Inbox merge tags. The `value` tokens must match exactly what the inbox
 * backend substitutes in RenderMessageTemplateAction (simple {{token}}
 * replacement, no dotted keys), so chips serialise to the right placeholder.
 */
export const INBOX_MERGE_TAGS: MergeTagRegistry = [
  {
    id: 'recipient',
    name: 'Recipient',
    tags: [
      {
        id: 'first_name',
        name: 'First name',
        value: '{{first_name}}',
        sample: 'Jane',
      },
      {
        id: 'contact_name',
        name: 'Contact name',
        value: '{{contact_name}}',
        sample: 'Jane Doe',
      },
      {
        id: 'contact_email',
        name: 'Contact email',
        value: '{{contact_email}}',
        sample: 'jane@example.com',
      },
    ],
  },
  {
    id: 'venue',
    name: 'Venue & team',
    tags: [
      {
        id: 'venue_name',
        name: 'Venue name',
        value: '{{venue_name}}',
        sample: 'The Red Lion',
      },
      {
        id: 'org_name',
        name: 'Organisation name',
        value: '{{org_name}}',
        sample: 'Pub Co',
      },
      {
        id: 'agent_name',
        name: 'Your name',
        value: '{{agent_name}}',
        sample: 'Sam',
      },
    ],
  },
]
